/// <reference path="event-tracking.js" />
/// <summary>
/// Google tracking events for the PDP page
/// </summary>
(function ($) {
    evo.tracking.setCategory('Results Product Click');
    evo.tracking.setActions({
        'h': 'Home',
        'o': 'Opposite'
    });

    $(function () {
        evo.$.body.on('refresh.results', function () {
            evo.tracking.bindTracking(evo.$.body);
        });
    });
})(jQuery);